import styled from 'styled-components'
const ModalContainer = styled.div`
    display: none;
`
const Container = styled.div`
 max-width: 767px;
 width: 100%;

`
const Heading = styled.div`
    position: relative;
    display: flex;
    align-items: flex-start;
 > h6 {
        text-align: left;
    margin: 30px 0;
    background: #ffffff;
    position: relative;
    z-index: 1;
    /* display: inline; */
    padding-right: 21px;
        }
    ::after {
            content: '';
    display: block;
    height: 1px;
    background-color: #979797;
    position: absolute;
    width: 100%;
    top: 50%;
        }
    `
const Body = styled.div``
const RequestDate = styled.div`
    display: flex;
    align-items: center;
    gap: 15px;
    margin-top: 30px;
    .app-input-text {
        margin:0;
    }
`
const RecurrencePattern = styled.div`
   
`
const BoxWrapper = styled.div``
const RangeofRecurrence = styled.div``
const PatternWrapper = styled.div`
    display: flex;
   
`
const RadioWrapper = styled.div`
    max-width: 111px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    border-right: 1px solid #979797;
    flex:1;
`
const RadioData = styled.div`
    padding-left: 20px;
    flex:1;
`


export { Container, Heading, Body, RequestDate, RecurrencePattern, ModalContainer,BoxWrapper, RangeofRecurrence, PatternWrapper, RadioWrapper, RadioData};